export const areaNormalFontFamily = "'Area Normal', sans-serif";
export const CARD_LOGO: Record<string, string> = {
    visa: '/images/svg/visa_logo@1x.svg',
    mastercard: '/images/svg/mastercard_logo.svg',
    'american express': '/images/svg/american_express_logo.svg',
    discover: '/images/svg/discover_logo.svg',
    'diners club': '/images/svg/diners_club_logo.svg',
    'union pay': '/images/svg/union_pay_logo.svg',
    jcb: '/images/svg/jcb_logo.svg',
};
